<!-- <div class="card">
    <div class="card-body">
        <div class="card-title">
            <div class="row">
                <div class="col-md-8">
                    <span class="h4 net-sale-card-title">Net Sales</span> <span><img class="vertical-align-top info-icon" src="../../../../assets/images/dashboard-images/Group 6.png" alt="group-icon"></span>
                </div>
                <div class="col-md-4 text-end">
                    <div class="input-group mb-3 date-picker-group">
                        <div ngbDropdown class="input-group-text p-0 border-color-input">
                            <button class="btn datepicker-btn" id="periodDropDown" ngbDropdownToggle>
                                {{selectDateoption}} <i class="mdi mdi-menu-up up"></i><i class="mdi mdi-menu-down down"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <ng-container *ngFor="let type of dateFilteroptions;">
                                    <button ngbDropdownItem [ngClass]="selectDateoption === type ? 'disabled' : ''"
                                        [disabled]="selectDateoption === type"
                                        (click)="selectedDateOption(type)">{{type}}</button>
                                </ng-container>
                            </div>
                        </div>
                        <div class="net-sale-daterange-picker form-group text-start form-control border-0 p-0">

                            <div class="datepickerwrap form-control" daterangepicker [options]="options"
                                (selected)="selectedDate($event)">
                                <img src="../../../../assets/images/dashboard-images/bx-calendar.png" class="picker-icon">
                                <span class="date-text"><span class="display-date">{{startDateDisplayFormatted}}</span> - <span
                                        class="display-date">{{endDateDisplayFormatted}}</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="net-sales-graph-details mt-1">
            <div class="row">
                <div class="col-md-3">
                    <div class="net-sales-details">
                        <div class="net-sales-comarision-one">
                            <p *ngIf="selectDateoption !== 'custom'" class="time-range-name">{{selectDateoption}}</p>
                            <p *ngIf="selectDateoption == 'custom'" class="time-range-name">{{customDate}}</p>
                            <h4 class="total-sales">$ {{currentData | number : '1.2-2'}}</h4>
                        </div>
                        <div class="net-sales-variable-data">
                            <span class="indication-badge  ml-1" [ngClass]="checkNegative(percentage) ? 'red': 'green'">
                                {{checkNegative(percentage) ? percentage :
                                showPlusData(percentage) }}%
                            </span>
                            <span class="m-1 previous-period-text">From previous period</span>
                        </div>
                        <div class="net-sales-view-btn-section">
                        </div>
                        <div class="net-sales-comarision-two mt-4">
                            <p class="time-range-name">{{prevSelectDateoption}}</p>
                            <h4 class="total-sales">$ {{prevData | number : '1.2-2'}}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-9">
                    <ng-container *ngIf="!loader">
                        <apx-chart class="apex-charts" dir="ltr" [series]="netSalesData.series"
                            [chart]="netSalesData.chart" [tooltip]="netSalesData.tooltip" [yaxis]="netSalesData.yaxis"
                            [legend]="netSalesData.legend" [plotOptions]="netSalesData.plotOptions"
                            [grid]="netSalesData.grid" [stroke]="netSalesData.stroke" [xaxis]="netSalesData.xaxis"
                            [colors]="netSalesData.colors" [fill]="netSalesData.fill" [labels]="netSalesData.labels"
                            [markers]="netSalesData.markers">
                        </apx-chart>
                    </ng-container>
                    <ng-container *ngIf="loader" height="400px">
                        <div class="grapgh-loader">
                            <span class="loader1"></span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="d-flex card-space flex-wrap flex-lg-nowrap mb-4 ">
 <!-- <div class="card ActionsMain m-0">
    <h5 class="f-20 fw-600 mt-3">Quick Actions1</h5>
    <div class="scrollable-content">
      <ul class="action-list">
        <li>
          <a routerLink="/sales/transactions" class="action-link">
            <span class="action-text">{{ "Transactions" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/sales/orders" class="action-link">
            <span class="action-text">{{ "Orders" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/sales/gross-transaction" class="action-link">
            <span class="action-text">{{ "Sales Transaction" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/sales/gross-shift" class="action-link">
            <span class="action-text">{{ "Daily Services Transactions" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/labor/tip-report" class="action-link">
            <span class="action-text">{{ "Tip" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/labor/payroll" class="action-link">
            <span class="action-text">{{ "Payroll" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/exception/refunds" class="action-link">
            <span class="action-text">{{ "Refunds" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/reports/labor/cashout" class="action-link">
            <span class="action-text">{{ "Cashout" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/employees/employeelist/employee-home" class="action-link">
            <span class="action-text">{{ "Workforce" | translate | async }}</span>
          </a>
        </li>
        <li>
          <a routerLink="/menumanagement/menus/menu-home" class="action-link">
            <span class="action-text">{{ "Menu-management" | translate | async }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div> -->

  <div class="card net-sale-graph br-0 net-sales-new d-flex flex-row  m-0">
    <!-- <div class="card-body net-sales-RTL col-md-2" style="border-right: 0.5px solid #666666;">
      <div class="col-md-8 p-0">
        <h5 class="fw-600 mb-4 font-size-20 pd-left10">
          {{ "Quick actions" | translate | async }}
        </h5>
      </div>
      <div class="d-flex">
        <div class="quick-actions-list d-flex flex-column">

          <div (click)="navigateAndClose('sales/transactions')" class="quick-action-item cursor-pointer">
            <span class="icon">
              <i class="fas fa-chart-line"></i>
            </span>
            <span class="text">{{ "Transactions" | translate | async }}</span>
          </div>


          <div (click)="navigateAndClose('employees/employeelist')" class="quick-action-item cursor-pointer">
            <span class="icon">
              <i class="fas fa-users"></i>
            </span>
            <span class="text">{{ "Employees" | translate | async }}</span>
          </div>


          <div (click)="navigateAndClose('menumanagement/menus')" class="quick-action-item cursor-pointer">
            <span class="icon">
              <i class="fas fa-utensils"></i>
            </span>
            <span class="text">{{ "Menu" | translate | async }}</span>
          </div>


          <div (click)="navigateAndClose('business-settings/location')" class="quick-action-item cursor-pointer">
            <span class="icon">
              <i class="fas fa-edit"></i>
            </span>
            <span class="text">{{ "Locations" | translate | async }}</span>
          </div>

        </div>
      </div>
    </div> -->

    <div class="card-body net-sales-RTL">
      <div class="row justify-content-between net-sales-details-RTL">
        <div class="col-md-8 p-0">
          <h5 class="fw-600 mb-4 font-size-20 pd-left10">
            {{ "Net Sales" | translate | async }}
            <i
              class="f-10 fas fa-info-circle vertical-align-super"
              [ngbPopover]="'Net sales is the total value of sales after all deductions (Net Sales = Gross Sales - Refunds - Taxes - Discounts - Delivery Fees)' | translate | async"
              triggers="mouseenter:mouseleave"
              [popoverTitle]="'Net Sales' | translate | async"
              placement="right"
            ></i>
          </h5>
        </div>
        <div class="col-md-4 w-fit p-0">
          <div class="input-group mb-3">
            <div ngbDropdown class="input-group-text p-0 border-color-input">
              <button
                class="btn datepicker-btn"
                id="periodDropDown"
                ngbDropdownToggle
              >
                {{ selectDateoption | translate | async }} <i class="mdi mdi-menu-up up"></i
                ><i class="mdi mdi-menu-down down"></i>
              </button>
              <div
                ngbDropdownMenu
                aria-labelledby="dropdownBasic1"
                class="fw-500 f-12"
              >
                <ng-container *ngFor="let type of dateFilteroptions">
                  <button
                    ngbDropdownItem
                    [ngClass]="selectDateoption === type ? 'disabled' : ''"
                    [disabled]="selectDateoption === type"
                    (click)="selectedDateOption(type)"
                  >
                    {{ type | translate | async }}
                  </button>
                </ng-container>
              </div>
            </div>
            <div
              class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
            >
              <!-- <div
                class="datepickerwrap form-control"
                daterangepicker
                [options]="options"
                (selected)="selectedDate($event)"
              >
                <span class="date-text ms-2"
                  ><span class="display-date">{{
                    startDateDisplayFormatted
                  }}</span>
                  -
                  <span class="display-date">{{
                    endDateDisplayFormatted
                  }}</span></span
                >
                <img src="../../../../assets/images/dashboard-images/bx-calendar.png" class="ms-3 picker-icon">
              </div> -->
              <div class="datepickerwrap form-control" (click)="picker.open()">
                <span class="date-text ms-2">
                  <span class="display-date">{{
                    startDateDisplayFormatted | translate | async
                  }}</span>
                  -
                  <span class="display-date">{{ endDateDisplayFormatted| translate | async }}</span>
                </span>
                <img
                  src="../../../../assets/images/dashboard-images/bx-calendar.png"
                  class="ms-3 picker-icon"
                />

                <div class="mat-datepicker-hide">
                  <mat-date-range-input [rangePicker]="picker">
                    <input
                      matStartDate
                      placeholder="Start date"
                      [(ngModel)]="a1"
                    />
                    <input
                      matEndDate
                      placeholder="End date"
                      [(ngModel)]="a2"
                      (ngModelChange)="selectedDate($event)"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="d-flex align-self-center date-iconset mb-3">
                      <span class="cus-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-minus"
                              width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                              fill="none" stroke-linecap="round" stroke-linejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <rect x="4" y="5" width="16" height="16" rx="2"></rect>
                              <line x1="16" y1="3" x2="16" y2="7"></line>
                              <line x1="8" y1="3" x2="8" y2="7"></line>
                              <line x1="4" y1="11" x2="20" y2="11"></line>
                              <line x1="10" y1="16" x2="14" y2="16"></line>
                          </svg>
                      </span>
                      <input type="text"
                          ngxDaterangepickerMd
                          [(ngModel)]="selected"
                          (ngModelChange)="onDateRangeChange($event)"
                          [showCustomRangeLabel]="true"
                          [alwaysShowCalendars]="true"
                          [ranges]="ranges"
                          [linkedCalendars]="true"
                          [isInvalidDate] = "isInvalidDate"
                          [showClearButton]="true"
                          class="form-control"
                          placeholder="Select please..."/>


                  </div> -->
        </div>
      </div>

      <div class="chart-part">
        <div class="">
          <div class="f-14 fw-500 net-chart-RTL-details">
            <ng-container
              *ngIf="selectDateoption !== 'custom'"
              class="time-range-name"
              >{{ selectDateoption | translate | async }}
            </ng-container>
            <ng-container
              *ngIf="selectDateoption == 'custom'"
              class="time-range-name"
              >{{ customDate | translate | async }} </ng-container
            ><br />

            <div class="font-size-13 fw-500 d-flex align-items-center  net-chart-RTL-Previous" style="gap: 5px;">
              <!-- <span
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(percentage)
                    ? 'danger-badge'
                    : checkZeroInc(percentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              > -->
              <span class="fw-600 font-size-24">
                {{ currency }}{{ cardData?.sale?.value | number : "1.2-2" }}
                <!-- change -->
                <!-- {{ currency }}{{ currentData | number : "1.2-2" }} -->
              </span>
              <span
                   [ngClass]="
                     checkNegative(cardData?.sale?.percentage)
                       ? 'danger-badge'
                       : checkZeroInc(cardData?.sale?.percentage)
                       ? 'zero-badge'
                       : 'sucess-badge'
                   "
                   class="f-12 text-nowrap"
                 >
                {{
                checkNegative(cardData?.sale?.percentage)
                  ? cardData?.sale?.percentage
                  : showPlusData(cardData?.sale?.percentage)
                }}%
              <!-- change -->
                <!-- {{
                  checkNegative(percentage)
                    ? percentage
                    : showPlusData(percentage)
                }}% -->
                </span>
              </div>
             <div class="f-13 fw-500"> {{ "From Previous Period" | translate | async }}</div>
          </div>
          <div class="font-size-14 fw-500 net-currency-ptice-RTL">
            <!-- <span class="text-capitalize">{{ prevSelectDateoption | translate | async }}</span> <br /> -->
            <span class="fw-600 font-size-16">
              {{ currency }}{{ prevData | number : "1.2-2" }}</span
            >
          </div>
          <div class="mb-1 net-view-btn-dashboard">
            <!-- routerLink="/sales/transactions/{{ startDateDisplay }}/{{
                endDateDisplay
              }}" -->
            <button
              class="sec-btn"
              routerLink="/sales/transactions/{{ startDateDisplay }}/{{
                endDateDisplay
              }}"
            >
              {{ "View Details" | translate | async }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="ms-1 icon icon-tabler icon-tabler-chevron-right"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="9 6 15 12 9 18"></polyline>
              </svg>
            </button>
          </div>

        </div>
        <div class="chart-theme">
          <div id="chart">
            <!-- <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                          [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
                          [dataLabels]="chartOptions.dataLabels"></apx-chart> -->
            <ng-container *ngIf="!loader">
              <apx-chart
                class="apex-charts"
                dir="ltr"
                [series]="netSalesData.series"
                [chart]="netSalesData.chart"
                [tooltip]="netSalesData.tooltip"
                [yaxis]="netSalesData.yaxis"
                [legend]="netSalesData.legend"
                [plotOptions]="netSalesData.plotOptions"
                [grid]="netSalesData.grid"
                [stroke]="netSalesData.stroke"
                [xaxis]="netSalesData.xaxis"
                [colors]="netSalesData.colors"
                [fill]="netSalesData.fill"
                [labels]="netSalesData.labels"
                [markers]="netSalesData.markers"
              >
              </apx-chart>
            </ng-container>
            <ng-container *ngIf="loader" height="400px">
              <div class="grapgh-loader">
                <span class="loader1"></span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
